import { IStrings } from 'localization/IStrings';

export const boolToYesNo = (val: boolean, strings: IStrings): string => (val ? strings.yes : strings.no);
